import { createApi } from '@reduxjs/toolkit/query/react';
import { authBaseQuery } from '../utils/authBaseQuery';

const baseUrl =
  process.env.NEXT_PUBLIC_USE_SECURITY === 'true'
    ? process.env.NEXT_PUBLIC_API_SECURITY
    : process.env.NEXT_PUBLIC_API_CHECKOUT;

export const paymentApi = createApi({
  reducerPath: 'paymentMethodsApi',
  baseQuery: authBaseQuery({
    baseUrl,
  }),
  keepUnusedDataFor: 3600,
  tagTypes: ['PaymentMethods'],
  endpoints: (build) => ({
    getPaymentMethods: build.query({
      query: (id) => `events-core/api/v1/events/${id}/payments`,
      providesTags: (result, error, id) => [{ type: 'PaymentMethods', id }],
    }),
  }),
});

export const { useGetPaymentMethodsQuery, useLazyGetPaymentMethodsQuery } =
  paymentApi;

export const {
  getPaymentMethods: { useQueryState: useGetPaymentMethodsQueryState },
} = paymentApi.endpoints;
